// src/pages/missions/MissionForm.js
import React, { useState } from 'react'
import { X, Save } from 'lucide-react'
import { db } from '../../firebaseConfig'
import { collection, addDoc, Timestamp } from 'firebase/firestore'

const MISSION_TYPES = [
  { value: 'order_completed', label: 'Order selesai' },
  { value: 'order_accept', label: 'Terima order' },
  { value: 'online_duration', label: 'Aktif sekian jam' },
  { value: 'rating_received', label: 'Dapat rating' },
  { value: 'revenue_target', label: 'Capai omzet' },
]

export default function MissionForm({ scope, onClose }) {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [missionType, setMissionType] = useState('order_completed')
  const [target, setTarget] = useState(1)
  const [bonus, setBonus] = useState(0)
  const [serviceType, setServiceType] = useState('all')
  const [role, setRole] = useState('therapist') // ✨ BARU: State untuk Role Mitra
  
  // ✨ BARU: State untuk Target Misi Spesifik
  const [targetAudience, setTargetAudience] = useState('all') // all | level | specific_uid
  const [targetLevel, setTargetLevel] = useState('2') // Default ke level 2
  const [targetUids, setTargetUids] = useState('') // Input UID manual

  const [startAt, setStartAt] = useState('')
  const [endAt, setEndAt] = useState('')
  const [saving, setSaving] = useState(false)

  const submit = async () => {
    if (!title || !startAt || !endAt) {
      alert('Lengkapi data misi')
      return
    }

    setSaving(true)

    try {
      const col = scope === 'daily' ? 'missions_daily' : 'missions_weekly'

      await addDoc(collection(db, col), {
        title,
        description,
        missionType, // ENUM TETAP
        target: Number(target),
        bonus: Number(bonus),
        serviceType, // all | massage | cleaning | dll
        role, // ✨ BARU: Menyimpan role (therapist / cleaner) ke Firestore
        
        // ✨ BARU: Menyimpan pengaturan target audiens
        targetAudience, 
        targetLevel: targetAudience === 'level' ? Number(targetLevel) : null,
        targetUids: targetAudience === 'specific_uid' ? targetUids.split(',').map(u => u.trim()) : [],
        
        isActive: true,
        createdAt: Timestamp.now(),
        startAt: Timestamp.fromDate(new Date(startAt)),
        endAt: Timestamp.fromDate(new Date(endAt)),
      })

      onClose()
    } catch (e) {
      alert('Gagal menyimpan misi')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="bg-gray-800 border border-gray-700 rounded-xl p-5 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-lg">
          Buat Misi {scope === 'daily' ? 'Harian' : 'Mingguan'}
        </h3>
        <button onClick={onClose}>
          <X size={18} />
        </button>
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <input
          className="col-span-2 p-2 rounded bg-gray-900 border border-gray-700"
          placeholder="Judul Misi"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <textarea
          className="col-span-2 p-2 rounded bg-gray-900 border border-gray-700"
          placeholder="Deskripsi Misi"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <select
          className="p-2 rounded bg-gray-900 border border-gray-700"
          value={missionType}
          onChange={(e) => setMissionType(e.target.value)}
        >
          {MISSION_TYPES.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>

        <input
          type="number"
          className="p-2 rounded bg-gray-900 border border-gray-700"
          placeholder="Target"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
        />

        <input
          type="number"
          className="p-2 rounded bg-gray-900 border border-gray-700"
          placeholder="Bonus (Rp)"
          value={bonus}
          onChange={(e) => setBonus(e.target.value)}
        />

        <select
          className="p-2 rounded bg-gray-900 border border-gray-700"
          value={serviceType}
          onChange={(e) => setServiceType(e.target.value)}
        >
          <option value="all">Semua Layanan</option>
          <option value="massage">Massage</option>
          <option value="cleaning">Cleaning</option>
        </select>

        {/* ✨ BARU: Dropdown untuk Role Mitra */}
        <select
          className="p-2 rounded bg-gray-900 border border-gray-700"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="therapist">Divisi: Therapist</option>
          <option value="cleaner">Divisi: Cleaner</option>
        </select>

        {/* ✨ BARU: Pilihan Target Audiens */}
        <select
          className="col-span-2 p-2 rounded bg-gray-900 border border-gray-700 font-semibold text-blue-400"
          value={targetAudience}
          onChange={(e) => setTargetAudience(e.target.value)}
        >
          <option value="all">🌍 Kirim ke Semua Mitra</option>
          <option value="level">⭐ Kirim ke Level Tertentu</option>
          <option value="specific_uid">🎯 Kirim ke UID Mitra Tertentu (Spesifik)</option>
        </select>

        {/* ✨ BARU: Muncul jika pilih target Level */}
        {targetAudience === 'level' && (
          <select
            className="col-span-2 p-2 rounded bg-gray-900 border border-blue-700"
            value={targetLevel}
            onChange={(e) => setTargetLevel(e.target.value)}
          >
            <option value="1">Level 1: MITRA (Dasar)</option>
            <option value="2">Level 2: MITRA HANDAL</option>
            <option value="3">Level 3: TOP MITRA</option>
          </select>
        )}

        {/* ✨ BARU: Muncul jika pilih target UID */}
        {targetAudience === 'specific_uid' && (
          <input
            className="col-span-2 p-2 rounded bg-gray-900 border border-blue-700"
            placeholder="Masukkan UID Mitra (Pisahkan dengan koma jika lebih dari satu)"
            value={targetUids}
            onChange={(e) => setTargetUids(e.target.value)}
          />
        )}

        <input
          type="datetime-local"
          className="p-2 rounded bg-gray-900 border border-gray-700"
          value={startAt}
          onChange={(e) => setStartAt(e.target.value)}
        />

        <input
          type="datetime-local"
          className="p-2 rounded bg-gray-900 border border-gray-700"
          value={endAt}
          onChange={(e) => setEndAt(e.target.value)}
        />
      </div>

      <div className="flex justify-end mt-4">
        <button
          onClick={submit}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-sm"
        >
          <Save size={16} /> Simpan Misi
        </button>
      </div>
    </div>
  )
}
